import { render, staticRenderFns } from "./UpdatedTag.vue?vue&type=template&id=167ae11e&scoped=true&"
import script from "./UpdatedTag.vue?vue&type=script&lang=js&"
export * from "./UpdatedTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167ae11e",
  null
  
)

export default component.exports